/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import TPrimaryDeviceCard, {
  PrimaryDeviceCardAnalytics
} from './PrimaryDeviceCard';
import './styles.scss';
import { PrimaryDeviceCardProps } from './types';

/**
 * UI Toolkit : Primary device card
 * @public
 */
const PrimaryDeviceCard: React.FC<PrimaryDeviceCardProps> = ({
  id,
  deviceNickName,
  deviceModelName,
  deviceImage,
  hPPlusEnrolled,
  printerSupplyWidget,
  children,
  loading = false,
  onCardClick,
  trackId,
  actionList,
  ...rest
}) => {
  if (trackId) {
    return (
      <PrimaryDeviceCardAnalytics
        {...{
          id,
          actionList,
          deviceNickName,
          deviceModelName,
          deviceImage,
          hPPlusEnrolled,
          printerSupplyWidget,
          children,
          onCardClick,
          trackId,
          loading,
          ...rest
        }}
      />
    );
  }
  return (
    <TPrimaryDeviceCard
      {...{
        id,
        actionList,
        deviceNickName,
        deviceModelName,
        deviceImage,
        hPPlusEnrolled,
        printerSupplyWidget,
        children,
        loading,
        onCardClick
      }}
    />
  );
};

export default PrimaryDeviceCard;
